/* tslint:disable */
/* eslint-disable */
/**
 * Farseer API
 * Farseer API
 *
 * The version of the OpenAPI document: 3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var CustomColumnType;
(function (CustomColumnType) {
    CustomColumnType["Table"] = "TABLE";
    CustomColumnType["Number"] = "NUMBER";
})(CustomColumnType || (CustomColumnType = {}));
export function CustomColumnTypeFromJSON(json) {
    return CustomColumnTypeFromJSONTyped(json, false);
}
export function CustomColumnTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function CustomColumnTypeToJSON(value) {
    return value;
}
